import { IAccountUser } from '../../models/account-user';
import { ICompanyAccount } from '../../models/company-account';
import { IBucket } from '../../models/prostatic';
import { IResult } from '../../models/result-models';
import { IRole } from '../../models/role';
import {
    LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS,
    LOAD_COMPANY_ACCOUNT_USERS_SUCCESS,
    LOAD_COMPANY_ACCOUNTS_SUCCESS,
    LOAD_COMPANY_BUCKETS_SUCCESS,
    LOAD_COMPANY_ROLES_SUCCESS,
} from './company-actions';

interface LoadCompanyAccountsSuccess {
    type: 'LOAD_COMPANY_ACCOUNTS_SUCCESS';
    payload: IResult<ICompanyAccount[]>;
}

interface LoadCompanyBucketsSuccess {
    type: 'LOAD_COMPANY_BUCKETS_SUCCESS';
    payload: IResult<IBucket[]>;
}

interface LoadCompanyRolesSuccess {
    type: 'LOAD_COMPANY_ROLES_SUCCESS';
    payload: IResult<IRole[]>;
}

interface LoadCompanyAccountUsersSuccess {
    type: 'LOAD_COMPANY_ACCOUNT_USERS_SUCCESS';
    payload: IResult<IAccountUser[]>;
}

interface LoadAccountContactsSuccess {
    type: 'LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS';
    payload: IResult<IAccountUser[]>;
}

const initialSate = {
    ok: false,
    data: [],
};

export const companyAccountsReducer = (
    state: IResult<ICompanyAccount[]> = initialSate,
    action: LoadCompanyAccountsSuccess
) => {
    switch (action.type) {
        case LOAD_COMPANY_ACCOUNTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

export const companyBucketsReducer = (
    state: IResult<IBucket[]> = initialSate,
    action: LoadCompanyBucketsSuccess
) => {
    switch (action.type) {
        case LOAD_COMPANY_BUCKETS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

export const companyRolesReducer = (
    state: IResult<IRole[]> = initialSate,
    action: LoadCompanyRolesSuccess
) => {
    switch (action.type) {
        case LOAD_COMPANY_ROLES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

export const accountUsersReducer = (
    state: IResult<IAccountUser[]> = initialSate,
    action: LoadCompanyAccountUsersSuccess
) => {
    switch (action.type) {
        case LOAD_COMPANY_ACCOUNT_USERS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

export const accountContactsReducer = (
    state: IResult<IAccountUser[]> = initialSate,
    action: LoadAccountContactsSuccess
): IResult<IAccountUser[]> => {
    switch (action.type) {
        case LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};
